module.exports = __webpack_public_path__ + "e13.no2.f39be88e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/e13.no2.jpg
// module id = ddgT
// module chunks = 0